<template>
  <div id="runningTrack" class="margin-subpages">
    <div class="pt-32 px-20 pb-24 chart-container">
      <div class="sub-title px-12">
        <span class="fs-24" style="text-transform: lowercase"
          >{{ $utils("addCommasInNumber", distance_all) }}
          {{ $t("happilyVillage.km") }}</span
        >
        {{ $t("happilyVillage.Distance_Traveled") }}
      </div>
      <div class="relative" style="height: 340px">
        <div
          class="center absolute-mid"
          v-if="loadingChartStatus"
        >
          <loading-even></loading-even>
        </div>
        <canvas
          ref="runnginTrackBarchart"
          height="340px"
          class="barchart-style"
        ></canvas>
      </div>
    </div>

    <div id="runningTrack" class="mt-32">
      <div class="flex-row-between align-items-center">
        <div class="sub-title">
          {{ $t("happilyVillage.Running_Track_Leaderboard") }}
        </div>
        <div class="relative">
          <el-input
            @keyup.native="typeingSearchRunningTrack"
            class="input-style"
            style="width: 200px; height: 40px;"
            autosize
            :placeholder="$t('global.Search')"
            v-model="inputSearchRunnginTrack"
            clearable
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
      <div class="mt-12">
        <el-tabs id="tabHeaderStyle" v-model="activeTabs">
          <el-tab-pane name="today" default>
            <span slot="label" class="title-bar">{{
              $t("happilyVillage.Today")
            }}</span>
            <div>
              <el-table
                @sort-change="rtDaySort"
                class="table-happily-village mt-16"
                :data="runningtrack_day.dataTable"
                style="width: 100%"
                :empty-text="
                  loadingTableToday
                    ? ' '
                    : !loadingTableToday && inputSearchRunnginTrack === ''
                    ? 'No Running Track Activity'
                    : 'No results found...'
                "
              >
                <el-table-column
                  :label="$t('happilyVillage.Rank')"
                  sortable="custom"
                  align="center"
                  width="80"
                  prop="rank"
                >
                  <template slot-scope="scope">
                    <div class="fs-700 mb-auto">{{ scope.row.rank }}</div>
                    <div>&nbsp;</div>
                  </template>
                </el-table-column>
                <el-table-column
                  sortable="custom"
                  :label="$t('happilyVillage.Name')"
                  width="300"
                  prop="name"
                >
                  <template slot-scope="scope">
                    <div class="flex-column">
                      <span class="fs-13 fw-500">{{ scope.row.name }}</span>
                      <span class="opa-03 fs-11">{{
                        scope.row.booster_key === undefined
                          ? "No active booster"
                          : scope.row.booster_name
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  sortable="custom"
                  :label="$t('happilyVillage.Distance')"
                  width="300"
                  prop="distance"
                >
                  <template slot-scope="scope">
                    <div class="normal">
                      {{ renderDistanceData(scope.row.distance) }} km
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div
                class="center mt-20 mb-40 pt-20 pb-40"
                v-if="loadingTableToday"
              >
                <loading-even></loading-even>
              </div>
              <div class="flex-center pagination mt-10">
                <el-pagination
                  @current-change="pageCurrentDayChange"
                  :current-page="runningtrack_day.page"
                  :page-size="10"
                  :pager-count="5"
                  layout="prev, pager, next"
                  :total="runningtrack_day.results"
                ></el-pagination>

                <span class="results-status">
                  {{
                    runningtrack_day.dataTable.length > 10
                      ? 10
                      : runningtrack_day.dataTable.length
                  }}
                  {{ $t("happilyVillage.results_from") }}
                  {{ $utils("addCommasInNumber", runningtrack_day.results) }}
                  {{ $t("happilyVillage.results") }}
                </span>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="thisWeek">
            <span slot="label" class="title-bar">{{
              $t("happilyVillage.This_week")
            }}</span>
            <div>
              <el-table
                @sort-change="rtWeekSort"
                class="table-happily-village"
                :data="runningtrack_week.dataTable"
                style="width: 100%"
                :empty-text="
                  loadingTableWeek
                    ? ' '
                    : !loadingTableWeek && inputSearchRunnginTrack === ''
                    ? 'No Running Track Activity'
                    : 'No results found...'
                "
              >
                <el-table-column
                  :label="$t('happilyVillage.Rank')"
                  sortable="custom"
                  align="center"
                  width="80"
                  prop="rank"
                >
                  <template slot-scope="scope">
                    <div class="fs-700 mb-auto">{{ scope.row.rank }}</div>
                    <div>&nbsp;</div>
                  </template>
                </el-table-column>
                <el-table-column
                  sortable="custom"
                  :label="$t('happilyVillage.Name')"
                  width="300"
                  prop="name"
                >
                  <template slot-scope="scope">
                    <div class="flex-column">
                      <span class="fs-13 fw-500">{{ scope.row.name }}</span>
                      <span class="opa-03 fs-11">{{
                        $t("happilyVillage.No_Active_Boosters")
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  sortable="custom"
                  :label="$t('happilyVillage.Distance')"
                  width="300"
                  prop="distance"
                >
                  <template slot-scope="scope">
                    <div class="normal">
                      {{ renderDistanceData(scope.row.distance) }} km
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div
                class="center mt-20 mb-40 pt-20 pb-40"
                v-if="loadingTableWeek"
              >
                <loading-even></loading-even>
              </div>
              <div class="flex-center pagination mt-10">
                <el-pagination
                  @current-change="pageCurrentWeekChange"
                  :current-page="runningtrack_week.page"
                  :page-size="10"
                  :pager-count="5"
                  layout="prev, pager, next"
                  :total="runningtrack_week.results"
                ></el-pagination>
                <span class="results-status">
                  {{
                    runningtrack_week.dataTable.length > 10
                      ? 10
                      : runningtrack_week.dataTable.length
                  }}
                  {{ $t("happilyVillage.results_from") }}
                  {{ $utils("addCommasInNumber", runningtrack_week.results) }}
                  {{ $t("happilyVillage.results") }}
                </span>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="thisMonth">
            <span slot="label" class="title-bar">{{ $t("happilyVillage.This_month") }}</span>
            <div>
              <el-table
                @sort-change="rtMonthSort"
                class="table-happily-village"
                :data="runningtrack_month.dataTable"
                style="width: 100%"
                :empty-text="
                  loadingTableMonth
                    ? ' '
                    : !loadingTableMonth && inputSearchRunnginTrack === ''
                    ? 'No Running Track Activity'
                    : 'No results found...'
                "
              >
                <el-table-column
                  :label="$t('happilyVillage.Rank')"
                  sortable="custom"
                  align="center"
                  width="80"
                  prop="rank"
                >
                  <template slot-scope="scope">
                    <div class="fs-700 mb-auto">{{ scope.row.rank }}</div>
                    <div>&nbsp;</div>
                  </template>
                </el-table-column>
                <el-table-column
                  sortable="custom"
                  :label="$t('happilyVillage.Name')"
                  width="300"
                  prop="name"
                >
                  <template slot-scope="scope">
                    <div class="flex-column">
                      <span class="fs-13 fw-500">{{ scope.row.name }}</span>
                      <span class="opa-03 fs-11">{{
                        $t("happilyVillage.No_Active_Boosters")
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  sortable="custom"
                  :label="$t('happilyVillage.Distance')"
                  width="300"
                  prop="distance"
                >
                  <template slot-scope="scope">
                    <div class="normal">
                      {{ renderDistanceData(scope.row.distance) }} km
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div
                class="center mt-20 mb-40 pt-20 pb-40"
                v-if="loadingTableMonth"
              >
                <loading-even></loading-even>
              </div>
              <div class="flex-center pagination mt-10">
                <el-pagination
                  @current-change="pageCurrentMonthChange"
                  :current-page="runningtrack_month.page"
                  :page-size="10"
                  :pager-count="5"
                  layout="prev, pager, next"
                  :total="runningtrack_month.results"
                ></el-pagination>

                <span class="results-status">
                  {{
                    runningtrack_month.dataTable.length > 10
                      ? 10
                      : runningtrack_month.dataTable.length
                  }}
                  {{ $t("happilyVillage.results_from") }}
                  {{ $utils("addCommasInNumber", runningtrack_month.results) }}
                  {{ $t("happilyVillage.results") }}
                </span>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane name="lastMonth">
            <span slot="label" class="title-bar">{{ $t("happilyVillage.Last_Month") }}</span>
            <div>
              <el-table
                @sort-change="rtLastMonthSort"
                class="table-happily-village"
                :data="runningtrack_last_month.dataTable"
                style="width: 100%"
                :empty-text="
                  loadingTableMonth
                    ? ' '
                    : !loadingTableLastMonth && inputSearchRunnginTrack === ''
                    ? 'No Running Track Activity'
                    : 'No results found...'
                "
              >
                <el-table-column
                  :label="$t('happilyVillage.Rank')"
                  sortable="custom"
                  align="center"
                  width="80"
                  prop="rank"
                >
                  <template slot-scope="scope">
                    <div class="fs-700 mb-auto">{{ scope.row.rank }}</div>
                    <div>&nbsp;</div>
                  </template>
                </el-table-column>
                <el-table-column
                  sortable="custom"
                  :label="$t('happilyVillage.Name')"
                  width="300"
                  prop="name"
                >
                  <template slot-scope="scope">
                    <div class="flex-column">
                      <span class="fs-13 fw-500">{{ scope.row.name }}</span>
                      <span class="opa-03 fs-11">{{
                        $t("happilyVillage.No_Active_Boosters")
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  sortable="custom"
                  :label="$t('happilyVillage.Distance')"
                  width="300"
                  prop="distance"
                >
                  <template slot-scope="scope">
                    <div class="normal">
                      {{ renderDistanceData(scope.row.distance) }} km
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div
                class="center mt-20 mb-40 pt-20 pb-40"
                v-if="loadingTableLastMonth"
              >
                <loading-even></loading-even>
              </div>
              <div class="flex-center pagination mt-10">
                <el-pagination
                  @current-change="pageCurrentLastMonthChange"
                  :current-page="runningtrack_last_month.page"
                  :page-size="10"
                  :pager-count="5"
                  layout="prev, pager, next"
                  :total="runningtrack_last_month.results"
                ></el-pagination>

                <span class="results-status">
                  {{
                    runningtrack_last_month.dataTable.length > 10
                      ? 10
                      : runningtrack_last_month.dataTable.length
                  }}
                  {{ $t("happilyVillage.results_from") }}
                  {{ $utils("addCommasInNumber", runningtrack_last_month.results) }}
                  {{ $t("happilyVillage.results") }}
                </span>
              </div>
            </div>
          </el-tab-pane>


          <el-tab-pane name="allTime">
            <span slot="label" class="title-bar">{{ $t("happilyVillage.All_time") }}</span>
            <div>
              <el-table
                @sort-change="rtAllSort"
                class="table-happily-village"
                :data="user_running.dataTable"
                style="width: 100%"
                :empty-text="
                  loadingTableAll
                    ? ' '
                    : !loadingTableAll && inputSearchRunnginTrack === ''
                    ? 'No Running Track Activity'
                    : 'No results found...'
                "
              >
                <el-table-column
                  :label="$t('happilyVillage.Rank')"
                  sortable="custom"
                  align="center"
                  width="80"
                  prop="rank"
                >
                  <template slot-scope="scope">
                    <div class="fs-700 mb-auto">{{ scope.row.rank }}</div>
                    <div>&nbsp;</div>
                  </template>
                </el-table-column>
                <el-table-column
                  sortable="custom"
                  :label="$t('happilyVillage.Name')"
                  width="300"
                  prop="name"
                >
                  <template slot-scope="scope">
                    <div class="flex-column">
                      <span class="fs-13 fw-500">{{ scope.row.name }}</span>
                      <span class="opa-03 fs-11">{{
                        $t("happilyVillage.No_Active_Boosters")
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  sortable="custom"
                  :label="$t('happilyVillage.Distance')"
                  width="300"
                  prop="distance"
                >
                  <template slot-scope="scope">
                    <div class="normal">
                      {{ renderDistanceData(scope.row.distance) }} km
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div
                class="center mt-20 mb-40 pt-20 pb-40"
                v-if="loadingTableAll"
              >
                <loading-even></loading-even>
              </div>
              <div class="flex-center pagination mt-10">
                <el-pagination
                  @current-change="pageCurrentAllChange"
                  :current-page="user_running.page"
                  :page-size="10"
                  :pager-count="5"
                  layout="prev, pager, next"
                  :total="user_running.results"
                ></el-pagination>

                <span class="results-status">
                  {{
                    user_running.dataTable.length > 10
                      ? 10
                      : user_running.dataTable.length
                  }}
                  {{ $t("happilyVillage.results_from") }}
                  {{ $utils("addCommasInNumber", user_running.results) }}
                  {{ $t("happilyVillage.results") }}
                </span>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "runningTrack",
  components: {
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
  },
  created() {
    this.$store.dispatch("happilyvillageRunningtrack/getRunningTrackAll");
  },
  watch: {
    runningtrack_graphmonth() {
      if (this.running_track_bar_chart) {
        this.running_track_bar_chart.destroy();
      }
      this.randerBarChartRunningTrack();
    },
    inputSearchRunnginTrack() {
      if (!this.inputSearchRunnginTrack) {
        this.typeingSearchRunningTrack();
      }
    },
  },
  computed: {
    runningtrack_graphmonth() {
      return this.$store.getters["happilyvillage/runningtrack_graphmonth16"];
    },
    distance_all() {
      return this.$store.getters["happilyvillage/distance_all16"];
    },
    runningtrack_day() {
      let thisDayData =
        this.$store.getters["happilyvillage/runningtrack_day_all"];
      if (thisDayData.length && this.loadingTableToday) {
        this.loadingTableToday = false;
        this.$store.dispatch(
          "happilyvillageRunningtrack/dayOnCreate",
          thisDayData
        );
      }
      return this.$store.getters["happilyvillageRunningtrack/toDayData"];
    },
    runningtrack_week() {
      let weeklyData =
        this.$store.getters["happilyvillage/runningtrack_week_all"];
      if (weeklyData.length && this.loadingTableWeek) {
        this.loadingTableWeek = false;
        this.$store.dispatch(
          "happilyvillageRunningtrack/weekOnCreate",
          weeklyData
        );
      }
      return this.$store.getters["happilyvillageRunningtrack/weekData"];
    },
    runningtrack_month() {
      let monthData =
        this.$store.getters["happilyvillage/runningtrack_month_all"];
      if (monthData.length && this.loadingTableMonth) {
        this.loadingTableMonth = false;
        this.$store.dispatch(
          "happilyvillageRunningtrack/monthOnCreate",
          monthData
        );
      }
      return this.$store.getters["happilyvillageRunningtrack/monthData"];
    },


    runningtrack_last_month() {
      let lastmonthData =
        this.$store.getters["happilyvillage/runningtrack_last_month_all"];
        // console.log('lastmonthData',lastmonthData)
      if (lastmonthData.length && this.loadingTableLastMonth) {
     
        this.loadingTableLastMonth = false;
        this.$store.dispatch(
          "happilyvillageRunningtrack/lastMonthOnCreate",
          lastmonthData
        );
      }
      return this.$store.getters["happilyvillageRunningtrack/lastMonthData"];
    },
    user_running() {
      let allData =
        this.$store.getters["happilyvillageRunningtrack/user_running"];
      if (allData.length && this.loadingTableAll) {
        this.loadingTableAll = false;
        this.$store.dispatch("happilyvillageRunningtrack/allOnCreate", allData);
      }
      return this.$store.getters["happilyvillageRunningtrack/allData"];
    },
  },
  data() {
    return {
      loadingTableLastMonth: true,
      loadingTableToday: true,
      loadingTableWeek: true,
      loadingTableMonth: true,
      loadingTableAll: true,
      loadingChartStatus: true,
      inputSearchRunnginTrack: "",
      typingSearch: null,
      downloadRunningTrackBar: false,
      activeTabs: "today",
    };
  },
  mounted() {
    if (this.running_track_bar_chart) {
      this.running_track_bar_chart.destroy();
    }
    this.randerBarChartRunningTrack()
  },
  methods: {
    renderDistanceData(distance) {
      return this.$utils("addCommasInNumber", (distance / 1000).toFixed(2));
    },
    exportTable(val) {
      console.log("Download" + val); // TODO: Export excel file function!
      this.downloadRunningTrackBar = true;
      setTimeout(() => {
        this.downloadRunningTrackBar = false;
      }, 3000);
    },
    randerBarChartRunningTrack() {
      var runnginTrackBarchart = this.$refs.runnginTrackBarchart;
      const months = [];
      const value = [];
      for (const x in this.runningtrack_graphmonth) {
        months.push(this.runningtrack_graphmonth[x].month);
        value.push(this.runningtrack_graphmonth[x].value);
      }

      // Reverse the arrays to show oldest months first
      months.reverse();
      value.reverse();

      if (runnginTrackBarchart) {
        this.loadingChartStatus = false;
        const runningTrackChartData = {
          labels: months,
          datasets: [
            {
              label: "Distance Traveleds",
              data: value,
              backgroundColor: "#f7d8ba",
              borderColor: "#EF8011",
              borderWidth: 1,
              datalabels: {
                color: "#EF8011",
              },
            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.plugins.tooltip = {
          enabled: false,
        };
        options.layout = {
          padding: {
            top: 36,
          },
        },
        options.plugins.datalabels = {
          formatter: function(value, context) {
            let str = value.toString().split(".");
            if (str[0].length >= 4) {
              str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
            }
            str = str[0];
            if (str == "0") {
              str = "";
            }
            return str;
          }
        }
        this.running_track_bar_chart = new Chart(
          runnginTrackBarchart.getContext("2d"),
          {
            plugins: [ChartDataLabels],
            type: "bar",
            data: runningTrackChartData,
            options: options,
          }
        );
      }
    },
    typeingSearchRunningTrack() {
      clearTimeout(this.typingSearch);
      this.typingSearch = setTimeout(() => {
        this.$store.commit(
          "happilyvillageRunningtrack/setInputSearching",
          this.inputSearchRunnginTrack
        );
      }, this.variable.typingTimeout);
    },
    pageCurrentDayChange(val) {
      this.$store.commit("happilyvillageRunningtrack/setRtDayPage", val);
    },
    rtDaySort({ column, prop, order }) {
      if (order) {
        this.$store.commit("happilyvillageRunningtrack/setDaySorting", {
          field: column.property,
          order: order,
        });
      }
    },
    pageCurrentWeekChange(val) {
      this.$store.commit("happilyvillageRunningtrack/setRtWeekPage", val);
    },
    rtWeekSort({ column, prop, order }) {
      if (order) {
        this.$store.commit("happilyvillageRunningtrack/setWeekSorting", {
          field: column.property,
          order: order,
        });
      }
    },
    pageCurrentMonthChange(val) {
      this.$store.commit("happilyvillageRunningtrack/setRtMonthPage", val);
    },
    
    rtMonthSort({ column, prop, order }) {
      if (order) {
        this.$store.commit("happilyvillageRunningtrack/setMonthSorting", {
          field: column.property,
          order: order,
        });
      }
    },
    pageCurrentLastMonthChange(val) {
      this.$store.commit("happilyvillageRunningtrack/setRtLastMonthPage", val);
    },
    rtLastMonthSort({ column, prop, order }) {
      if (order) {
        this.$store.commit("happilyvillageRunningtrack/setLastMonthSorting", {
          field: column.property,
          order: order,
        });
      }
    },
    pageCurrentAllChange(val) {
      this.$store.commit("happilyvillageRunningtrack/setRtAllPage", val);
    },
    rtAllSort({ column, prop, order }) {
      if (order) {
        this.$store.commit("happilyvillageRunningtrack/setAllSorting", {
          field: column.property,
          order: order,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.barchart-style {
  border-radius: 4px;
}
.chart-container {
  border-radius: 24px;
  background: rgba(0,0,0,0.03);
}
.sub-title {
  text-transform: capitalize;
}
.bg-black-001 {
  background-color: rgba(000, 000, 000, 0.01);
}
.icon-export {
  position: absolute;
  top: 3px;
  padding-left: 32px;
}
.table-happily-village {
  font-size: 13px;
}
</style>

<style>
</style>
